import script from "./FocusedLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./FocusedLayout.vue?vue&type=script&setup=true&lang=ts"

import "./FocusedLayout.vue?vue&type=style&index=0&id=51c58440&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c58440"]])

export default __exports__